import { daScheduleRoleKeyToId } from "mocks/roleDA";

export interface ScheduleTableColumn {
  id: string;
  label: string;
  hasSort?: boolean;
  dateCol?: boolean;
  tableNumber: number;
  date?: string;
}

export const SCHEDULE_TABLE_COLUMNS: ScheduleTableColumn[] = [
  { id: "checkbox", label: "", hasSort: false, tableNumber: 1 },
  { id: "user", label: "Name", hasSort: true, tableNumber: 1 },
  { id: "badge", label: "Badge", hasSort: true, tableNumber: 1 },
  { id: "hours", label: "Hours", hasSort: true, tableNumber: 1 },
  { id: "role", label: "Role", hasSort: true, tableNumber: 2 },
  { id: "transporter_id", label: "Transporter ID", hasSort: true, tableNumber: 2 },
  { id: "payroll", label: "Payroll", hasSort: false, tableNumber: 2 },
  { id: "tenured", label: "Tenured", hasSort: true, tableNumber: 2 },
  { id: "sun", label: "Sunday", dateCol: true, tableNumber: 2 },
  { id: "mon", label: "Monday", dateCol: true, tableNumber: 2 },
  { id: "tue", label: "Tuesday", dateCol: true, tableNumber: 2 },
  { id: "wed", label: "Wednesday", dateCol: true, tableNumber: 2 },
  { id: "thr", label: "Thursday", dateCol: true, tableNumber: 2 },
  { id: "fri", label: "Friday", dateCol: true, tableNumber: 2 },
  { id: "sat", label: "Saturday", dateCol: true, tableNumber: 2 },
  { id: "sun-2", label: "Sunday 2", dateCol: true, tableNumber: 2 },
  { id: "mon-2", label: "Monday 2", dateCol: true, tableNumber: 2 },
  { id: "tue-2", label: "Tuesday 2", dateCol: true, tableNumber: 2 },
  { id: "wed-2", label: "Wednesday 2", dateCol: true, tableNumber: 2 },
  { id: "thr-2", label: "Thursday 2", dateCol: true, tableNumber: 2 },
  { id: "fri-2", label: "Friday 2", dateCol: true, tableNumber: 2 },
  { id: "sat-2", label: "Saturday 2", dateCol: true, tableNumber: 2 },
];

export const SCHEDULE_ROLE_SETTINGS = [
  {
    id: "DA Roles",
    name: "da-roles",
    subList: [
      { name: "Standard", id: daScheduleRoleKeyToId.driver},
      { name: "Flex", id: daScheduleRoleKeyToId.flex},
      { name: "Helper", id: daScheduleRoleKeyToId.helper},
      { name: "Rescue", id: daScheduleRoleKeyToId.rescue},
      { name: "Stand By", id: daScheduleRoleKeyToId.standby},
      { name: "Training", id: daScheduleRoleKeyToId.training},
      { name: "Client Cancelled", id: daScheduleRoleKeyToId.clientCancelled},
      { name: "MYCU Cancelled", id: daScheduleRoleKeyToId.mycuCancelled},
      { name: "Rejected", id: daScheduleRoleKeyToId.rejected},
      { name: "No Show", id: daScheduleRoleKeyToId.absent},
    ],
  },
  {
    id: "Operation Roles",
    name: "operation-roles",
    subList: [
      { name: "Dispatcher", id: daScheduleRoleKeyToId.dispatcher},
      { name: "Support Dispatcher", id: daScheduleRoleKeyToId.supportDispatcher},
      { name: "Supervisor", id: daScheduleRoleKeyToId.supervisor},
      { name: "Fleet Coordinator", id: daScheduleRoleKeyToId.fleetCoordinator},
      { name: "Performance Coordinator", id: daScheduleRoleKeyToId.performanceCoordinator},
    ],
  },
];

export const SCHEDULE_DATE_COLUMN_IDS = new Set(
  SCHEDULE_TABLE_COLUMNS.filter((col) => col.dateCol).map((col) => col.id),
);

export const getScheduleTableColumns = (
  activeColumns: string[],
  isTwoWeekTable: boolean,
  tableNumber: number,
  width: number,
) => {
  const visibleColumns = activeColumns?.length
    ? activeColumns
    : ["checkbox", "user", "badge", "hours", "role", "transporter_id", "payroll", "tenured"];

  return SCHEDULE_TABLE_COLUMNS.filter((col) => {
    const columnTable =
      width < 840 && ["user", "badge", "hours"].includes(col.id) ? 2 : col.tableNumber;

    if (columnTable !== tableNumber) return false;
    if (col.id.includes("-2") && !isTwoWeekTable) return false;
    if (col.id === "checkbox" || col.dateCol) return true;
    return visibleColumns.includes(col.id);
  });
};
